// The site icon store (shared/site-icons.js) ships as a lazy chunk: the start page never needs it,
// only site tiles and a finished page load in a tab.
import { get } from "../shared/settings-store.js";
import { canStore } from "../shared/site-icons.js";

let loading = null;
export let icons = null; // the store, once loaded

export const iconsAllowed = () => canStore(get);

export function loadIcons() {
	if (!loading) loading = import(__RVM.siteIconsJs)
		.then((m) => { icons = m.iconStore(iconsAllowed); return m; })
		.catch(() => { loading = null; return null; });
	return loading;
}
